__turbopack_context__.v({
  "input": "date-input-module-scss-module__V2pGTa__input",
});
